
import { TypedUseSelectorHook, useSelector } from 'react-redux';
import { ApplicationState } from './appThunkAction'

import LoginReducer from './Login/reducer';

import SearchReducer from './Search/reducer';
import BookmarkReducer from './Bookmark/reducer';

import RecommendationReducer from './Recommendation/reducer';
import MeetingReducer from './Meeting/reducer';
import StoryReducer from './Story/reducer';
import PopularStoryReducer from './Popular/reducer';
// Reducer collections
export const reducers = {
    login: LoginReducer,
    search: SearchReducer,
    bookmark: BookmarkReducer,
    recommendation: RecommendationReducer,
    meeting: MeetingReducer,
    story: StoryReducer,
    popularStories: PopularStoryReducer
};


// Typed useSelector for react-redux
export const useTypedSelector: TypedUseSelectorHook<ApplicationState> = useSelector;
